import 'font-awesome/css/font-awesome.css';

import { Component } from 'react';
import FontAwesome from 'react-fontawesome';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import './style.css';

export default class LightTextInput extends Component {
  static propTypes = {
    className: PropTypes.string,
    disabled: PropTypes.bool,
    iconName: PropTypes.string,
    onInputChanged: PropTypes.func,
    placeholder: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.string,
  };

  static defaultProps = {
    disabled: false,
    iconName: null,
    onInputChanged: () => null,
    placeholder: undefined,
    type: 'text',
    value: '',
  };

  render() {
    const {
      disabled,
      value,
      placeholder,
      type,
      onInputChanged,
      iconName,
      className,
    } = this.props;

    return (
      <div
        className={classNames('LightTextInput', className, {
          LightButtonDisabled: disabled,
        })}
      >
        {iconName ? <FontAwesome name={iconName} /> : null}
        <input
          disabled={disabled}
          onChange={(event) => onInputChanged(event.target.value)}
          placeholder={placeholder}
          type={type}
          value={value || ''}
        />
      </div>
    );
  }
}
